import { observable, action } from "mobx";
import { post } from "../services/ajax.service";

class DashboardStore {
  @observable participants_data = {};
  @observable claims_data = {};
  @observable highest_drugs = [];
  @observable highest_participants = [];
  @observable highest_claims = [];
  @observable generic_sum_of_total_cost = 0;
  @observable generic_sum_of_total_claims = 0;
  @observable url = "/api/v1/dashboardactions";
  @observable toptiles = {
    total_pariticipants: 0,
    total_spend: 0,
    pmpm: 0,
    total_claims: 0,
    average_claim_cost: 0
  };

  @observable drug_classification = [
    {
      branded: [],
      generic: [],
      specialty: [],
      date: []
    }
  ];
  @observable leftmiddlegraph = [];

  @action getTopTiles = async data => {
    let response = await post(
      `${this.url}/getTopTiles`,
      data
    );
    this.toptiles.total_pariticipants =
      response.data.participants[0].TOTAL_PARTICIPANTS;
    this.toptiles.total_spend = response.data.claims[0].TOTAL_SPEND;
    this.toptiles.pmpm = response.data.pmpm[0].PMPM;
    this.toptiles.total_claims = response.data.claims[0].TOTAL_CLAIMS;
    this.toptiles.average_claim_cost =
      response.data.claims[0].AVERAGE_CLAIM_COST;
  };

  @action highestDrugs = async data => {
    let response = await post(
      `${this.url}/highestDrugs`,
      data
    );
    this.highest_drugs = response.data.drugs;
  };

  @action highestParticipants = async data => {
    let response = await post(
      `${this.url}/highestParticipants`,
      data
    );
    this.highest_participants = response.data.participants;
  };

  @action highestClaims = async data => {
    let response = await post(
      `${this.url}/highestClaims`,
      data
    );
    this.highest_claims = response.data.claims;
  };

  getSum_all_items(branded, generic, specialty) {
    let max_length = Math.max(branded.length, generic.length, specialty.length);
    let total_cost = 0;
    let total_claims = 0;
    for (var i = 0; i < max_length; i++) {
      if (i < branded.length) {
        total_claims = parseInt(branded[i].claims_count) + total_claims
        total_cost = parseFloat(branded[i].total_cost) + total_cost
      }
      if (i < generic.length) {
        total_claims = parseInt(generic[i].claims_count) + total_claims
        total_cost = parseFloat(generic[i].total_cost) + total_cost
      }
      if (i < specialty.length) {
        total_claims = parseInt(specialty[i].claims_count) + total_claims
        total_cost = parseFloat(specialty[i].total_cost) + total_cost
      }
    }
    this.generic_sum_of_total_claims = total_claims;
    this.generic_sum_of_total_cost = total_cost;
  }

  @action classifyDrugs = async data => {
    this.drug_classification = [{
      branded: [],
      generic: [],
      specialty: [],
      date: []
    }];
    let response = await post(
      `${this.url}/classifyDrugs`,
      data
    );
    this.drug_classification = response.data
    this.getSum_all_items(response.data[0].branded, response.data[0].generic, response.data[0].specialty);
  };

  @action leftMiddleGraph = async data => {
    this.leftmiddlegraph = []
    let response = await post(
      `${this.url}/leftmiddlegraph`,
      data
    );

    this.leftmiddlegraph = response.data;
  };
}

export default DashboardStore;
